// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * API module for handling customer logo file uploads in the Hardfin system.
 * Provides a specialized wrapper around the general file upload functionality.
 */
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file to be used as a customer's logo in the Hardfin system.
 * The file will be processed and stored with appropriate context for customer logo usage.
 *
 * @param file - The image file to upload as the customer's logo
 * @param customerId - The unique identifier of the customer to associate the logo with
 * @returns Promise resolving to the upload response from the file upload API
 * @throws Will throw an error if the file upload fails or if the file type is not supported
 */
export async function uploadCustomerLogo(file: File, customerId: string) {
  return uploadFile(file, { context: 'CUSTOMER_LOGO', entityId: customerId });
}
